import React, { useEffect } from "react";

import ErrorIcon from "@mui/icons-material/Error";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { logout } from "../../../Store/Slices/logout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { theme } from "../../../Customization/Theme";
import { CoreService } from "../../../Services/Apis/CoreApis";
import { useAppDispatch } from "../../../Store";
import { logoutAuth, useAuthStore } from "../../../Store/Slices/AuthSlice";
import { getDeviceInfo } from "../../../Utils/device-details";
import { useSocket } from "../../hooks/socket-context";

const SocketSessionInfoModel: React.FC = () => {
  const { socket, livechatSocket } = useSocket();
  const { data: authData } = useSelector(useAuthStore);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleDeviceChangeStatus = () => {
    CoreService.deviceChangeStatus({
      device: getDeviceInfo(),
      user_id: authData?.data?.user?.id,
      workspace_id: authData?.data?.user?.workspace_id,
      enabled: true,
    })
      .then((res: any) => {
        const channel = new BroadcastChannel("reload_channel");
        channel.postMessage({ type: "reload" });
      })
      .catch((err: any) => {
        console.error("Device Change Status Error", err);
      });
  };

  const handleUseHereBtn = () => {
    // window.location.reload();
    handleDeviceChangeStatus();
  };

  const handleCloseTab = () => {
    // window.open("about:blank", "_self");
    // window.close();

    let data = {
      user_id: authData?.data?.user?.id,
      workspace_id: authData?.data?.user?.workspace_id,
      device: getDeviceInfo(),
    };
    CoreService.userLogout(data).finally(() => {
      dispatch(logoutAuth(null));
      dispatch(logout()); // Dispatch the logout action
      window.localStorage.clear();
      const channel = new BroadcastChannel("reload_channel");
      channel.postMessage({ type: "logout" });
      navigate("/login", { replace: true });
      return;
    });
  };

  useEffect(() => {
    const channel = new BroadcastChannel("reload_channel");
    channel.onmessage = (event) => {
      if (event.data.type === "reload") {
        window.location.reload();
      }
      if (event.data.type === "logout") {
        window.location.href = "/login";
      }
    };

    return () => {
      channel.close();
    };
  }, []);

  if (socket && livechatSocket === false) {
    return (
      <React.Fragment>
        <Dialog
          open={true}
          onClose={undefined}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ backgroundColor: "white" }}
        >
          <DialogTitle style={{ lineHeight: "24px" }} id="alert-dialog-title">
            <ErrorIcon
              style={{
                color: theme.palette.default.error,
                verticalAlign: "top",
                marginRight: "0.5rem",
              }}
            />
            Multiple Sessions Detected
          </DialogTitle>
          <DialogContent style={{ maxWidth: "500px !important" }}>
            <DialogContentText id="alert-dialog-description">
              Account is active on a different browser. Click `Use Here` <br /> button
              to use in this browser.
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ gap: "1rem" }}>
            <Button
              variant="text"
              style={{ color: theme.palette.default.darkGrey }}
              onClick={handleCloseTab}
            >
              Logout
            </Button>
            <Button
              variant="contained"
              onClick={handleUseHereBtn}
              autoFocus={false}
            >
              Use Here
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }

  return null;
};

export default SocketSessionInfoModel;
